<template>
  <div>
    <div class="nav-bar">
      <div>
        <svg-btn :isActive="!isCollapse" @toggleClick="changeState()"></svg-btn>
      </div>
      <div class="userCompontent">
        <help-manual></help-manual>
        <full-screen></full-screen>
        <drop-down
          :user="username"
          :userheadimg="headimg"
          @showdialongcilck="showdialong()"
        ></drop-down>
      </div>
    </div>
    <!-- 弹框组件 -->

    <el-dialog
      title="账号设置"
      :visible.sync="dialogFormVisible"
      fullscreen
      custom-class="dialong"
    >
      <div class="dialong-image">
        <div class="headerimage">
          <img :src="headimg" alt="" srcset="" width="120" height="120" />
          <span class="dialong-title-span">
            <span>账号身份 ： {{ userRoleCode }}</span>
            <span>真实姓名 ： {{ username }}</span>
            <span>创建时间 ： {{ createtime }}</span>
          </span>
        </div>
        <el-upload
          class="upload-demo"
          action=""
          multiple
          :auto-upload="false"
          :on-change="uploadheaderimage"
          :show-file-list="false"
        >
          <el-button class="uploade" type="primary">上传头像</el-button>
        </el-upload>
      </div>
      <div class="dialong-alter">
        <el-row>
          <el-col :span="2" class="fs16">登录密码</el-col>
          <el-col :span="18" class="fs12"
            >建议您定期更换密码，设置一个包含字母，符号或数字中至少两项且长度超过6位的密码。</el-col
          >
          <el-col :span="4">
            <el-button type="danger" @click="innerVisiblepwd = true"
              >修改</el-button
            >
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2" class="fs16">手机绑定</el-col>
          <el-col :span="18" class="fs12"
            >您已绑定了手机<i style="color:red">{{ userphone }}</i
            >(您的手机为安全手机，但不能用于登录)</el-col
          >
          <el-col :span="4">
            <el-button type="danger" @click="innerVisiblephone = true"
              >修改</el-button
            >
          </el-col>
        </el-row>
      </div>
      <!-- 修改密码 -->
      <el-dialog
        width="500px"
        title="修改密码"
        :visible.sync="innerVisiblepwd"
        append-to-body
      >
        <el-form
          :label-position="positionform"
          :model="formpwd"
          :label-width="labelwidth"
        >
          <el-form-item label="旧密码">
            <el-input v-model="formpwd.oldLoginPwd"></el-input>
          </el-form-item>
          <el-form-item label="新密码">
            <el-input v-model="formpwd.newLoginPwd"></el-input>
          </el-form-item>
          <el-form-item label="确认密码">
            <el-input v-model="formpwd.sureLogepwd"></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align:right">
          <el-button @click="innerVisiblepwd = false">取 消</el-button>
          <el-button type="primary" @click="changepwd()">确定</el-button>
        </div>
      </el-dialog>
      <!-- 修改手机 -->
      <el-dialog
        width="500px"
        title="修改电话"
        :visible.sync="innerVisiblephone"
        append-to-body
      >
        <el-form
          :label-position="positionform"
          :model="formpwd"
          :label-width="labelwidth"
        >
          <el-form-item label="输入新号码">
            <el-input v-model="formphone.phoneNumber">
              <el-button
                slot="append"
                @click="sendCode()"
                :disabled="sendCodeStatus"
                >{{ sendCodeStatus ? content : titlesend }}</el-button
              >
            </el-input>
          </el-form-item>
          <el-form-item label="输入验证码">
            <el-input
              v-model="formphone.code"
              placeholder="请输入短信验证码"
            ></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align:right">
          <el-button @click="innerVisiblephone = false">取 消</el-button>
          <el-button type="primary" @click="uploadphone()">确定</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
import SvgBtn from "./svgbtn";
import DropDown from "./dropdown";
import FullScreen from "./fullscreen";
import HelpManual from "./helpmanual";
import { mapGetters } from "vuex";
export default {
  name: "HeaderBar",
  components: { SvgBtn, DropDown, FullScreen, HelpManual },
  data() {
    return {
      dialogFormVisible: false,
      innerVisiblepwd: false,
      innerVisiblephone: false,
      formpwd: {
        oldLoginPwd: "",
        newLoginPwd: "",
        sureLogepwd: ""
      },
      formphone: {
        phoneNumber: "",
        code: ""
      },
      sendCodeStatus: false, //是否发送验证码
      content: 60, //计时
      titlesend: "发送验证",
      positionform: "left",
      labelwidth: "250px",
      username: "", //用户名
      userRoleCode: "", //角色
      createtime: "", //创建时间
      userphone: "", //用户电话
      headimg: "", //用户头像
      loginName: ""
    };
  },
  computed: {
    ...mapGetters(["isCollapse", "userinfo"])
  },
  created() {
    this.getuserinfo();
  },
  methods: {
    changeState() {
      this.$store.dispatch("changeIsCollapse");
    },
    /*
     **  @description 子组件传值显示弹框
     **  @param {}
     **  @return
     **  @author shipingan
     */
    showdialong() {
      this.dialogFormVisible = true;
    },
    /*
     **  @description 获取用户信息展示
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getuserinfo() {
      let url = "/dapi/u/getUserInfoByUid";
      let params = {
        uid: this.userinfo.uid
      };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        if (res.status == 200) {
          let data = res.data.data;
          this.username = data.user_name;
          this.userRoleCode = data.userRoleCode;
          this.createtime = data.create_time;
          this.userphone = data.phone_number;
          this.headimg = data.user_header;
          this.loginName = data.loginName;
          let user = {
            username: this.username,
            account: this.userRoleCode
          };
          this.$store.dispatch("setUserName", user);
        }
      });
    },
    /*
     **  @description 修改密码
     **  @param {}
     **  @return
     **  @author shipingan
     */
    changepwd() {
      if (this.formpwd.sureLogepwd == this.formpwd.newLoginPwd) {
        let url = "/dapi/u/updateLoginPwd";
        let params = {
          uid: this.userinfo.uid,
          loginName: this.loginName,
          oldLoginPwd: this.formpwd.oldLoginPwd,
          newLoginPwd: this.formpwd.newLoginPwd
        };
        this.$axios.post(url, this.$qs.stringify(params)).then(res => {
          if (res.status == 200) {
            if (res.data.status == 200) {
              this.innerVisiblepwd = false;
              this.$message({
                message: res.data.message,
                type: "success"
              });
            } else {
              this.$message.error(res.data.message);
            }
          }
        });
      }
    },
    /*
     **  @description 上传头像
     **  @param {}
     **  @return
     **  @author shipingan
     */
    uploadheaderimage(file) {
      let url = "/dapi/u/uploadFile";
      let from = new FormData();
      from.append("file", file.raw);
      from.append("uid", this.userinfo.uid);

      this.$axios.post(url, from).then(res => {
        if (res.status == 200) {
          this.getuserinfo();
        }
      });
    },
    /*
     **  @description 发送验证码
     **  @param {}
     **  @return
     **  @author shipingan
     */
    sendCode() {
      let url = "/dapi/u/sendSms";
      let params = {
        phoneNumber: this.formphone.phoneNumber,
        uid: this.userinfo.uid
      };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          //发送短信成功
          this.sendCodeStatus = true;
          let time = setInterval(() => {
            this.content--;

            if (this.content == 0) {
              this.titlesend = "重新发送";
              this.sendCodeStatus = false;
              clearInterval(time);
            }
          }, 1000);
        } else {
          this.$message.error(data.message);
        }
      });
    },
    uploadphone() {
      let url = "/dapi/u/checkSmsCodeAndUpdatePhone";
      this.formphone.uid = this.userinfo.uid;
      let params = { ...this.formphone };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.$message({
            message: "绑定成功",
            type: "success"
          });
          this.innerVisiblephone = false;
          this.getuserinfo();
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.nav-bar {
  display: flex;
  justify-content: space-between;
}
.userCompontent {
  display: flex;
  text-align: right;
}
/deep/ .el-dialog__headerbtn{
  font-size: 40px!important;
}

/deep/ .el-dialog__header {
  width: 800px !important;
  margin: auto;
}
/deep/ .el-dialog__footer {
  width: 800px !important;
  margin: auto;
}
/deep/ .dialong > .el-dialog__body {
  width: 800px !important;
  border: 1px solid #ccc;
  margin: auto;
  .dialong-image {
    text-align: left;
    border-bottom: 1px solid rgb(14, 165, 202);
    margin-bottom: 30px;
    .headerimage {
      height: 120px;
      display: flex;
      img {
        border: 1px solid rgb(119, 212, 95);
        margin-right: 20px;
      }
      .dialong-title-span {
        display: flex;
        flex-direction: column;
        span {
          height: 20px;
          margin-bottom: 30px;
          line-height: 20px;
        }
      }
    }
    .upload-demo {
      padding-left: 20px;
      margin-bottom: 20px;
    }
  }
  .dialong-alter {
    .el-row {
      margin-bottom: 30px;
      border-bottom: 1px dashed #ccc;
      .fs12 {
        font-size: 12px;
        color: rgb(182, 199, 28);
      }
      .fs16 {
        font-size: 16px;
        color: #000;
      }
    }
  }
}
</style>
